/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Redirect, Route, Switch } from "react-router";
import { appRouterDefinitions } from "./appRouterDefinitions";
import AppRouterListener from "./AppRouterListener";
import LoadingIndicatorSuspense from "./Basis/Components/LoadingIndicatorSuspense";
import { environment } from "./Basis/environment";

export interface AppRouterSwitchProps {
    parentPath?: string;
    additionalProps?: any;
}

function NoMatch() {
    window.location.href = environment.baseUrl;
    return (<></>)
}

export default function AppRouterSwitch(props: AppRouterSwitchProps) {
    return (
        <Switch>
            {appRouterDefinitions
                .filter(
                    (appRouterDefinition) => appRouterDefinition.parentPath === props.parentPath
                )
                .sort((definition, otherDefinition) => {
                    const definitionPartCount = definition.path.split("/").length;
                    const otherDefinitionPartCount = otherDefinition.path.split("/").length;

                    if (definitionPartCount > otherDefinitionPartCount) {
                        return -1;
                    }

                    if (definitionPartCount < otherDefinitionPartCount) {
                        return 1;
                    }

                    return 0;
                })
                .map((appRouterDefinition, index) => {
                    return (
                        (appRouterDefinition.unauthorized || !environment.isSystem) &&
                        (
                            <Route
                                key={index}
                                path={appRouterDefinition.path}
                                exact={appRouterDefinition.exact}
                                render={(renderProps) => {
                                    const render = () => appRouterDefinition.render({
                                        ...renderProps,
                                        ...props.additionalProps,
                                    });
                                    return (
                                        <>
                                            <AppRouterListener appRouterDefinition={appRouterDefinition} />
                                            {(appRouterDefinition.exact || appRouterDefinition.parentPath) && <LoadingIndicatorSuspense>{render()}</LoadingIndicatorSuspense>}
                                            {!appRouterDefinition.exact && !appRouterDefinition.parentPath && render()}
                                        </>
                                    );
                                }}
                            />
                        )
                    );
                })}
            <Route path="/redirect" exact>
                <NoMatch></NoMatch>
            </Route>

            <Route render={() => <Redirect to="/redirect" /> } />
        </Switch>
    );
}
